module.exports = __webpack_public_path__ + "images/saintgobain0bfcb6dbd0af007c1d8f829ec56b9f06.png";